<template>
  <jade-box>
    <jade-group-header :title="$t('title')" />
    <div class="flex flex-col gap-5 p-5">
      <div class="flex flex-col gap-1">
        <jade-text
          variant="text-medium"
          weight="semibold"
          color="high"
        >
          {{ $t('documents.name') }}
        </jade-text>
        <jade-text
          color="medium"
          weight="medium"
        >
          {{ $t('documents.example') }}
        </jade-text>
      </div>
      <div class="flex flex-col gap-1">
        <jade-text
          variant="text-medium"
          weight="semibold"
          color="high"
        >
          {{ $t('documents.format') }}
        </jade-text>
        <jade-text
          color="medium"
          weight="medium"
        >
          {{ $t('documents.format.sub') }}
        </jade-text>
      </div>
      <div class="flex flex-col gap-1">
        <jade-text
          variant="text-medium"
          weight="semibold"
          color="high"
        >
          {{ $t('documents.size') }}
        </jade-text>
        <jade-text
          color="medium"
          weight="medium"
        >
          {{ $t('documents.size.sub') }}
        </jade-text>
      </div>
    </div>
  </jade-box>
</template>
<script>
import { JadeText, JadeBox, JadeGroupHeader } from '@jade'

export default {
  name: 'MassRepresentmentInstructions',
  components: {
    JadeText,
    JadeBox,
    JadeGroupHeader
  }
}
</script>
<i18n>
    {
      "pt-BR": {
        "title": "Instruções para envio da documentação",
        "documents.name": "O nome dos documentos devem estar de acordo com o identificador",
        "documents.example": "Exemplo: 12345678.pdf",
        "documents.format": "Atente-se ao formato do documento",
        "documents.format.sub": "O documento deve estar no formato PDF ou JPG",
        "documents.size": "Verifique o tamanho do envio",
        "documents.size.sub": "A soma do tamanho de todos os arquivos do lote não podem exceder o limite de 50MB"
      },
      "en-US": {
        "title": "Instructions for sending documentation",
        "documents.name": "The names of the documents must be in accordance with the identifier",
        "documents.example": "Example: 12345678.pdf",
        "documents.format": "Pay attention to the document format",
        "documents.format.sub": "The document must be in PDF or JPG format",
        "documents.size": "Check the size of the submission",
        "documents.size.sub": "The sum of the size of all files in the batch must not exceed the limit of 50MB"
      }
    }
    </i18n>
